import { request } from "./client";
import { registerMessages } from "./errors";

registerMessages({
  "admin access required": "Недостаточно прав",
  "name is required": "Не указано название",
  "failed to list places": "Не удалось загрузить площадки",
  "failed to create place": "Не удалось добавить площадку",
  "failed to update place": "Не удалось сохранить площадку",
  "failed to delete place": "Не удалось удалить площадку",
});

// Empty optional fields are left out of the server's JSON, not sent as null.
export interface Place {
  id: string;
  name: string;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  notes?: string | null;
  created_at: string;
}

export type PlaceInput = {
  name: string;
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  notes: string | null;
};

export const placesApi = {
  list: () => request<Place[] | null>("/api/places/"),

  create: (input: PlaceInput) =>
    request<Place>("/api/places/", { method: "POST", body: JSON.stringify(input) }),

  // The server overwrites every field, so fields the admin didn't touch are
  // sent back as they were.
  update: (id: string, input: PlaceInput) =>
    request<Place>(`/api/places/${encodeURIComponent(id)}`, {
      method: "PUT",
      body: JSON.stringify(input),
    }),

  remove: (id: string) =>
    request<void>(`/api/places/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
